import {
	getPersonalisedTargets,
	fetchMyReports,
	fetchReportData,
	fetchAdditional,
	fetchAdditionalData,
} from '../../../../api/reportAPI';

import {
	setPersonalisedTargetsPending,
	setPersonalisedTargetsSuccess,
	setPersonalisedTargetsFailed,
	setMyReportsPending,
	setMyReportsSuccess,
	setMyReportsFailed,
	setReportDataPending,
	setReportDataSuccess,
	setReportDataFailed,
	setAdditionalPending,
	setAdditionalSuccess,
	setAdditionalFailed,
	setAdditionalDataPending,
	setAdditionalDataSuccess,
	setAdditionalDataFailed,
} from './slice';

/**
 * Redux thunks for handling report-related async actions
 * @module reportThunks
 */

/**
 * Fetches personalised targets from the reporting API
 * Uses target setting gradepoints from the current dataset
 * @returns {AppThunk} Thunk action
 */
export const fetchPersonalisedTargets = (): AppThunk => async (dispatch, getState) => {
	dispatch(setPersonalisedTargetsPending());

	// Get all target setting gradepoints from state
	const targetSettingGradepoints =
		getState().context.reportContext.currentDataset?.targetSettingGradepoints ?? [];

	getPersonalisedTargets(targetSettingGradepoints)
		.then((response: any) => {
			let personalisedTargets = [];
			if (response && response.reports) {
				personalisedTargets = response.reports.map((x: any) => x);
			}
			dispatch(setPersonalisedTargetsSuccess(personalisedTargets));
		})
		.catch(() => {
			dispatch(setPersonalisedTargetsFailed());
		});
};

/**
 * Fetches reports and available academic years from the API
 * @returns {AppThunk} Thunk action
 */
export const fetchMyReportsThunk = (): AppThunk => async (dispatch) => {
	dispatch(setMyReportsPending());

	fetchMyReports()
		.then((result) => {
			dispatch(setMyReportsSuccess(result));
		})
		.catch(() => {
			dispatch(setMyReportsFailed());
		});
};

/**
 * Fetches report data for a specific ID and previous reports
 * @param {number} id - The report ID to fetch
 * @returns {AppThunk} Thunk action
 */
export const fetchReportDataThunk = (id: number): AppThunk => async (dispatch) => {
	dispatch(setReportDataPending());

	fetchReportData(id)
		.then((result) => {
			dispatch(setReportDataSuccess(result));
		})
		.catch(() => {
			dispatch(setReportDataFailed());
		});
};

/**
 * Fetches additional report data from the API
 * @returns {AppThunk} Thunk action
 */
export const fetchAdditionalThunk = (): AppThunk => (dispatch) => {
	dispatch(setAdditionalPending());

	fetchAdditional()
		.then((result) => {
			dispatch(setAdditionalSuccess(result));
		})
		.catch(() => {
			dispatch(setAdditionalFailed());
		});
};

/**
 * Fetches additional data for a specific report ID
 * @param {number} id - The report ID to fetch additional data for
 * @returns {AppThunk} Thunk action
 */
export const fetchAdditionalDataThunk = (id: number): AppThunk => async (dispatch) => {
	dispatch(setAdditionalDataPending());

	fetchAdditionalData(id)
		.then((result) => {
			dispatch(setAdditionalDataSuccess(result));
		})
		.catch(() => {
			dispatch(setAdditionalDataFailed());
		});
};
